import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-[#1A1D23]">
      <header className="h-16 flex items-center px-6 border-b border-white/5">
        <Link to="/" className="flex items-center gap-2" data-testid="datenschutz-logo">
          <div className="w-8 h-8 bg-[#EC2229] rounded-lg flex items-center justify-center">
            <span className="font-heading font-bold text-white text-sm">TX</span>
          </div>
          <span className="font-heading font-bold text-white text-lg">TrXL Performance</span>
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12" data-testid="datenschutz-content">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1 className="font-heading text-3xl font-bold text-white mb-8">Datenschutzerklärung</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-slate-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-base font-medium text-white mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Verantwortlicher</h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br /><br />
              TrXL Performance<br />
              Sven Trachsel<br />
              Schilfweg 5<br />
              28857 Syke<br /><br />
              Telefon: +49 172 549 8156<br />
              E-Mail: anfrage@trxl-performance.de
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Datenerfassung auf dieser Website</h2>
            <h3 className="text-base font-medium text-white mb-2">Wer ist verantwortlich für die Datenerfassung?</h3>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
              können Sie dem Abschnitt „Verantwortlicher" entnehmen.
            </p>

            <h3 className="text-base font-medium text-white mb-2 mt-4">Wie erfassen wir Ihre Daten?</h3>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B.
              um Daten handeln, die Sie in ein Kontaktformular eingeben oder bei der Registrierung angeben.
            </p>
            <p>
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere
              IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder
              Uhrzeit des Seitenaufrufs).
            </p>

            <h3 className="text-base font-medium text-white mb-2 mt-4">Wofür nutzen wir Ihre Daten?</h3>
            <p>
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten.
              Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Hosting</h2>
            <p>
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter. Die Datenverarbeitung erfolgt
              auf Servern in der Europäischen Union.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Auskunft über Ihre gespeicherten Daten zu erhalten (Art. 15 DSGVO)</li>
              <li>Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
              <li>Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
              <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
              <li>Widerspruch gegen die Verarbeitung einzulegen (Art. 21 DSGVO)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Registrierung und Nutzerkonto</h2>
            <p>
              Sie können sich auf unserer Website registrieren, um ein Nutzerkonto anzulegen. Die dabei eingegebenen
              Daten verwenden wir zur Bereitstellung und Nutzung des Fileservice-Portals. Rechtsgrundlage ist
              Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
            <p>
              Die bei der Registrierung erfassten Daten werden von uns gespeichert, solange Sie auf dieser Website
              registriert sind, und werden anschließend gelöscht. Gesetzliche Aufbewahrungsfristen bleiben unberührt.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">7. Zahlungsabwicklung</h2>
            <p>
              Für die Zahlungsabwicklung nutzen wir die Dienste von Stripe und PayPal. Ihre Zahlungsdaten werden
              direkt an den jeweiligen Zahlungsdienstleister übermittelt und nicht auf unseren Servern gespeichert.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">8. SSL-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine
              SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
              Browsers von „http://" auf „https://" wechselt.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">9. Cookies</h2>
            <p>
              Unsere Internetseiten verwenden sogenannte „Cookies". Cookies sind kleine Datenpakete und richten
              auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </p>
            <p>
              Wir verwenden technisch notwendige Cookies für die Funktionalität der Website (z.B. Spracheinstellung,
              Anmeldestatus).
            </p>
          </section>
        </div>
      </main>

      <footer className="py-6 px-6 border-t border-white/5">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} TrXL Performance. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="text-white">Datenschutz</Link>
            <Link to="/agb" className="hover:text-white transition-colors">AGB</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default DatenschutzPage;
